import React from 'react';
import { Share } from 'lucide-react';
import insta from '../assets/images/insta_btn.png';
import linkedin from '../assets/images/linkedin_btn.png';
import x from '../assets/images/x_btn.png';
import mail from '../assets/images/mail_btn.png';
import phone from '../assets/images/phone_btn.png';

interface ShareButtonsProps {
  hearticleId: string;
  onShare: (platform: string) => void;
}

const ShareButtons: React.FC<ShareButtonsProps> = ({ hearticleId, onShare }) => {
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Share this article',
          url: window.location.href,
        });
        onShare('native');
      } catch (error) {
        console.error('Error sharing:', error);
      }
    }
  };

  return (
    <div className="flex space-x-1 md:space-x-2">
      {/* Mobile Share Button */}
      <div className="block md:hidden">
        <button 
          onClick={handleNativeShare}
          className="w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-md hover:opacity-80 transition-opacity"
          aria-label="Share"
        >
          <Share className="w-5 h-5 text-gray-600" />
        </button>
      </div>

      {/* Desktop Social Media Buttons */}
      <div className="hidden md:flex md:space-x-2">
        <button 
          onClick={() => onShare('instagram')}
          className="w-12 h-12 overflow-hidden hover:opacity-80 transition-opacity"
          aria-label="Share on Instagram"
        >
          <img src={insta} alt="Share on Instagram" className="w-full h-full object-cover" />
        </button>
        <button 
          onClick={() => onShare('linkedin')} 
          className="w-12 h-12 overflow-hidden hover:opacity-80 transition-opacity"
          aria-label="Share on LinkedIn"
        >
          <img src={linkedin} alt="Share on LinkedIn" className="w-full h-full object-cover" />
        </button>
        <button 
          onClick={() => onShare('twitter')} 
          className="w-12 h-12 overflow-hidden hover:opacity-80 transition-opacity"
          aria-label="Share on Twitter"
        >
          <img src={x} alt="Share on Twitter" className="w-full h-full object-cover" />
        </button>
        <button 
          onClick={() => onShare('email')} 
          className="w-12 h-12 overflow-hidden hover:opacity-80 transition-opacity"
          aria-label="Share via Email"
        >
          <img src={mail} alt="Share via Email" className="w-full h-full object-cover" />
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;